import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const bookingConfigApi = {
  get: () => axios
    .get(`${API}/api/tenant-admin/booking-config`, { withCredentials: true })
    .then((r) => r.data),
  update: (body) => axios
    .patch(`${API}/api/tenant-admin/booking-config`, body, { withCredentials: true })
    .then((r) => r.data),
};
